import { ReactNode } from 'react'

interface CardHeaderProps {
	children?: ReactNode | ReactNode[]
}

const CardHeader = ({ children }: CardHeaderProps) => {
	return <div className="px-6 py-5">{children}</div>
}

export default CardHeader
